import { Injectable } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';

import { BehaviorSubject, filter } from 'rxjs';

declare let history: History;

@Injectable({
  providedIn: 'root',
})
export class RoutingStateService {
  public redirectEnabled = true;
  public prevRouteSubject: BehaviorSubject<string | null> = new BehaviorSubject(
    null,
  );
  private _history = [];
  private previousUrl = null;
  private readonly breakpointsConfig = this.device;

  constructor(
    private router: Router,
    private location: PlatformLocation,
    private device: DeviceDetectorService,
  ) {
    if (this.breakpointsConfig.isMobile()) {
      this.loadRouting();
    }

    this.prevRouteSubject.subscribe(
      (prevUrl: string | null) => (this.previousUrl = prevUrl),
    );

    this.location.onPopState(() => {
      if (this.breakpointsConfig.isMobile()) {
        if (!this.redirectEnabled) {
          history.pushState(null, null, this.getCurrentUrl());

          this.redirectEnabled = !this.redirectEnabled;
        }
      }
    });
  }

  public get history(): any[] {
    return this._history;
  }

  public loadRouting(): void {
    this.router.events
      .pipe(filter((evt) => evt instanceof NavigationEnd))
      .subscribe((evt: NavigationEnd) => {
        if (evt instanceof NavigationEnd) {
          this._history = [...this._history, evt.urlAfterRedirects];
          this.redirectEnabled = true;
        }
      });
  }

  public getCurrentUrl(): string {
    return this.router.url;
  }

  public get prevUrl(): string {
    return this.previousUrl;
  }
}
